import React from 'react';
import { motion } from 'framer-motion';

// Inline SVG icons for social media
const socialIcons = {
  facebook: (
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="currentColor">
      <path d="M12 2C6.477 2 2 6.477 2 12c0 5.084 3.657 9.317 8.438 10.187v-7.069h-2.54v-3.117h2.54v-2.329c0-2.527 1.492-3.921 3.781-3.921 1.096 0 2.24.195 2.24.195v2.465h-1.26c-1.247 0-1.644.776-1.644 1.572v1.889h2.753l-.44 3.117h-2.313v7.069C18.343 21.317 22 17.084 22 12c0-5.523-4.477-10-10-10z"/>
    </svg>
  ),
  instagram: (
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="currentColor">
      <path d="M12 2.163c3.204 0 3.584.012 4.85.07c3.252.148 4.619 1.637 4.767 4.85.058 1.265.07 1.645.07 4.85s-.012 3.584-.07 4.85c-.148 3.252-1.637 4.619-4.85 4.767-1.266.058-1.644.07-4.85.07s-3.584-.012-4.85-.07c-3.252-.148-4.619-1.637-4.767-4.85-.058-1.265-.07-1.645-.07-4.85s.012-3.584.07-4.85c.148-3.252 1.637-4.619 4.85-4.767 1.266-.058 1.644-.07 4.85-.07zm0-2.163c-3.259 0-3.667.014-4.947.072-4.358.201-6.78 2.623-6.98 6.98-.059 1.281-.073 1.689-.073 4.948s.014 3.668.072 4.948c.201 4.357 2.623 6.78 6.98 6.98 1.28.058 1.689.072 4.948.072s3.668-.014 4.948-.072c4.357-.201 6.78-2.623 6.98-6.98.058-1.281.072-1.689.072-4.948s-.014-3.667-.072-4.947c-.201-4.358-2.623-6.78-6.98-6.98-1.281-.059-1.69-.073-4.949-.073z"/>
      <circle cx="12" cy="12" r="4.25"/>
      <circle cx="16.5" cy="7.5" r="1.25"/>
    </svg>
  ),
  x: (
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="currentColor">
      <path d="M12 2C6.475 2 2 6.475 2 12c0 5.253 3.826 9.617 8.818 10.395.645.12.87-.279.87-.62v-2.164c-3.71 1.01-4.492-1.787-4.492-1.787-.604-1.532-1.474-1.942-1.474-1.942-1.205-.824.09-.81.09-.81 1.334.095 2.035 1.371 2.035 1.371 1.184 2.03 3.102 1.442 3.856 1.103.12-.857.464-1.442.845-1.77-2.946-.334-6.046-1.473-6.046-6.575 0-1.45.52-2.635 1.374-3.555-.138-.334-.598-1.68.13-3.518 0 0 1.125-.357 3.682 1.365 1.07-.297 2.214-.446 3.35-.452 1.136.006 2.28.155 3.35.452 2.557-1.722 3.682-1.365 3.682-1.365.728 1.838.268 3.184.13 3.518.854.92 1.374 2.105 1.374 3.555 0 5.111-3.105 6.241-6.064 6.564.475.405.904 1.205.904 2.427v3.593c0 .343.22.744.878.62C18.174 21.617 22 17.253 22 12c0-5.525-4.475-10-10-10z"/>
    </svg>
  ),
  whatsapp: (
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="currentColor">
      <path d="M12.038 2.03a9.962 9.962 0 00-7.85 16.516L2.013 22l3.659-1.207a9.97 9.97 0 005.41 1.488h.001c5.521 0 10.001-4.48 10.001-10.001 0-5.521-4.48-10.001-10.001-10.001zM17.5 15.657c-.247.436-.619.481-.977.168-.358-.313-1.168-.69-2.185-1.127-.478-.204-.847-.306-.994-.306-.151 0-.324.051-.55.204-.226.153-.615.462-.888.751-.274.289-.548.334-.994.111s-1.849-.785-3.518-2.613c-1.377-1.487-2.311-2.981-2.585-3.417-.274-.436-.027-.677.199-.904.199-.199.445-.487.671-.722.226-.226.302-.436.452-.671s.274-.487.452-.722c.178-.235.226-.436.151-.661-.075-.226-.671-1.614-.945-2.261-.274-.648-.55-.561-.751-.569-.2-.008-.436-.017-.671-.017-.226 0-.615.075-.945.378s-1.204 1.127-1.204 2.753c0 1.626 1.238 3.193 1.416 3.417.178.226 2.458 4.015 5.952 5.565 1.583.69 2.846 1.115 3.791 1.418.945.303 1.157.226 1.593.124.436-.102 1.433-.585 1.634-1.169.2-.584.2-.953.151-1.049-.049-.095-.178-.151-.378-.226z"/>
    </svg>
  ),
  tiktok: (
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="currentColor">
      <path d="M19.11 5.09c.14-.14.28-.29.41-.45.03-.04.06-.08.09-.13.31-.4.49-.9.49-1.44a.97.97 0 00-1-1c-.24 0-.47.05-.69.15-.36-.08-.73-.13-1.1-.13-3.64 0-6.6 2.96-6.6 6.6s2.96 6.6 6.6 6.6c.55 0 1.07-.08 1.58-.23a.985.985 0 00.1-.03c.1-.05.2-.1.3-.15a.99.99 0 00.08-.04 1.018 1.018 0 00.32-.23c.31-.28.56-.6.76-.94-.09-.01-.18-.03-.27-.03-2.61 0-4.73-2.12-4.73-4.73s2.12-4.73 4.73-4.73c.34 0 .67.04.99.1zM12 2C6.477 2 2 6.477 2 12s4.477 10 10 10 10-4.477 10-10S17.523 2 12 2z"/>
    </svg>
  )
};

const Footer = () => {
  const socialLinks = [
    { name: 'Facebook', url: '#', icon: socialIcons.facebook },
    { name: 'Instagram', url: 'https://www.instagram.com/hello.ibuyunn?igsh=eDRtcnVpcmNyOTNs', icon: socialIcons.instagram },
    { name: 'Twitter (X)', url: 'https://x.com/IBuy_Unn?t=du5pVSp-p7ktDKY3iT4Lhw&s=09', icon: socialIcons.x },
    { name: 'WhatsApp', url: 'https://chat.whatsapp.com/LmcchD8QjgBGiwHe1sNgk7?mode=ac_t', icon: socialIcons.whatsapp },
    { name: 'TikTok', url: 'https://www.tiktok.com/@ibuyunn_official?_t=ZS-8zMF6yaZtty&_r=1', icon: socialIcons.tiktok },
  ];

  return (
    <motion.footer
      initial={{ opacity: 0, y: 50 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.5, delay: 0.2 }}
      className="bg-emerald-950/50 backdrop-blur-xl text-gray-200 py-16 mt-20 rounded-t-3xl border-t border-emerald-900"
    >
      <div className="max-w-6xl mx-auto px-6 grid grid-cols-1 md:grid-cols-3 gap-10">
        {/* Left Section - uCart Info */}
        <div className="flex flex-col items-center md:items-start text-center md:text-left">
          <h2 className="text-3xl font-bold mb-4 text-emerald-400">uCart</h2>
          <p className="text-sm text-gray-400">
            Crafting digital solutions with pride and precision. Powered by DEVL.
          </p>
        </div>

        {/* Center Section - Social Media Handles */}
        <div className="flex flex-col items-center md:items-start text-center md:text-left">
          <h3 className="text-xl font-semibold mb-4 text-emerald-300">Social Media</h3>
          <ul className="flex flex-wrap justify-center md:justify-start gap-6">
            {socialLinks.map((link) => (
              <li key={link.name}>
                <a
                  href={link.url}
                  className="flex items-center space-x-2 text-gray-400 hover:text-emerald-400 transition-colors"
                  aria-label={link.name}
                >
                  <motion.div
                    whileHover={{ scale: 1.2, rotate: 10 }}
                    whileTap={{ scale: 0.9 }}
                    className="p-2 rounded-full border border-emerald-800 hover:border-emerald-500 transition-colors"
                  >
                    {link.icon}
                  </motion.div>
                </a>
              </li>
            ))}
          </ul>
        </div>

        {/* Right Section - Newsletter */}
        <div className="flex flex-col items-center md:items-start text-center md:text-left">
          <h3 className="text-xl font-semibold mb-4 text-emerald-300">Newsletter</h3>
          <form className="flex flex-col w-full max-w-sm gap-3">
            <input
              type="email"
              placeholder="Enter your email"
              className="p-3 rounded-xl bg-emerald-900/60 backdrop-blur-sm text-gray-100 placeholder-gray-500 border border-emerald-800 focus:outline-none focus:ring-2 focus:ring-emerald-500 transition-colors"
            />
            <motion.button
              className="bg-emerald-600 hover:bg-emerald-500 text-white font-bold rounded-full p-3 transition-colors shadow-lg"
              whileHover={{ scale: 1.05 }}
              whileTap={{ scale: 0.95 }}
            >
              Subscribe
            </motion.button>
          </form>
        </div>
      </div>

      <div className="mt-12 border-t border-emerald-900 text-center text-sm text-gray-500 pt-8 px-6">
        © {new Date().getFullYear()} iBUYUNN. All rights reserved.
      </div>
    </motion.footer>
  );
};

export default Footer;
